import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import { CityForSelectType } from '#home/types';
import { CityChooser } from '#components/city-chooser/CityChooser';
import cardLocationCityChooserCss from '../assets/card-location-city-chooser.module.scss';

type PropsType = {
  selectedCity: CityForSelectType|null;
  setSelectedCity: (selectedCity: CityForSelectType) => void
};

const CardLocationCityChooser: FC<PropsType> = ({
  selectedCity,
  setSelectedCity,
}) => {
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <CityChooser
      id="react-select-choose-city"
      styles={{
        input: (base) => ({
          ...base,
          color: null,
        }),
        loadingIndicator: (base) => ({
          ...base,
          color: null,
        }),
        singleValue: (base) => ({
          ...base,
          color: null,
        }),
      }}
      placeholder={(<FormattedMessage defaultMessage="your city" />)}
      classNames={{
        control: () => classNamesWithStyle(
          cardLocationCityChooserCss.cardLocationCityChooser__control,
          cardLocationCityChooserCss.cardLocationCityChooser__control_styleDefault,
          cardLocationCityChooserCss.cardLocationCityChooser__control_styleRed,
        ),
        input: () => classNamesWithStyle(
          cardLocationCityChooserCss.cardLocationCityChooser__input,
          cardLocationCityChooserCss.cardLocationCityChooser__input_styleDefault,
          cardLocationCityChooserCss.cardLocationCityChooser__input_styleRed,
        ),
        placeholder: () => classNamesWithStyle(
          cardLocationCityChooserCss.cardLocationCityChooser__placeholder,
          cardLocationCityChooserCss.cardLocationCityChooser__placeholder_styleDefault,
          cardLocationCityChooserCss.cardLocationCityChooser__placeholder_styleRed,
        ),
        loadingIndicator: () => classNamesWithStyle(
          cardLocationCityChooserCss.cardLocationCityChooser__loadingIndicator,
          cardLocationCityChooserCss.cardLocationCityChooser__loadingIndicator_styleDefault,
          cardLocationCityChooserCss.cardLocationCityChooser__loadingIndicator_styleRed,
        ),
        singleValue: () => classNamesWithStyle(
          cardLocationCityChooserCss.cardLocationCityChooser__singleValue,
          cardLocationCityChooserCss.cardLocationCityChooser__singleValue_styleDefault,
          cardLocationCityChooserCss.cardLocationCityChooser__singleValue_styleRed,
        ),
      }}
      defaultValue={selectedCity}
      onChange={setSelectedCity}
    />
  );
};

export { CardLocationCityChooser };
